<template>
  <v-layout>
    <v-flex>
      <v-row>
        <v-col cols="12" class="py-0">
          <v-container fluid pt-0>
            <v-row align="center">
              <h1 class="headline">Charges Types</h1>
              <v-spacer></v-spacer>
              <div>
                <list-visible-columns-and-filter
                  :visible-columns="visibleColumns"
                  :selectable-headers="selectableHeaders"
                  v-model="search"
                  @change="onVisibleColumnsChange"
                ></list-visible-columns-and-filter>
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" fab dark color="primary" @click="createItem">
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Create New Service Charge</span>
              </v-tooltip>
            </v-row>
          </v-container>
        </v-col>
      </v-row>

      <v-card>
        <v-data-table
          :headers="filteredHeaders"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.isAccommodation="{ item }">
            <v-checkbox
              v-model="item.node.isAccommodation"
              primary
              hide-details
              :disabled="true"
              class="ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.isActivity="{ item }">
            <v-checkbox
              v-model="item.node.isActivity"
              primary
              hide-details
              :disabled="true"
              class="ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.isTransport="{ item }">
            <v-checkbox
              v-model="item.node.isTransport"
              primary
              hide-details
              :disabled="true"
              class="ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.isTravel="{ item }">
            <v-checkbox
              v-model="item.node.isTravel"
              primary
              hide-details
              :disabled="true"
              class="ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.isOther="{ item }">
            <v-checkbox
              v-model="item.node.isOther"
              primary
              hide-details
              :disabled="true"
              class="ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-card>

      <charge-type-dialog
        v-model="selectedCharge"
        @input="onSaveCharge"
        :show="chargeEditorDialog"
        @close="chargeEditorDialog = false"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_CHARGE_TYPES_SEARCH_QUERY,
  CHARGE_TYPE_DELETE_MUTATION,
  CHARGE_TYPE_CREATE_MUTATION,
  CHARGE_TYPE_UPDATE_MUTATION,
} from "../../../../constants/graphql";
import DefaultListActions from "../../shared/DefaultListActions";
import ChargeTypeDialog from "./ChargeTypeDialog";
import SimpleListMixin from "../../../../mixins/SimpleListMixin";
import ListVisibleColumnsAndFilter from "../../shared/ListVisibleColumnsAndFilter";

export default {
  name: "ChargesTypesList",

  components: {
    DefaultListActions,
    ListVisibleColumnsAndFilter,
    ChargeTypeDialog,
  },
  mixins: [SimpleListMixin],
  data() {
    return {
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "name",
        "nominalCode",
        "taxCode",
        "rateTypeCode",
        "actions",
      ]),
      search: "",
      chargeTypes: {},
      selectedCharge: {},
      doSaveCharge: false,
      chargeEditorDialog: false,
      headers: [
        {
          text: "Name",
          value: "node.description",
          name: "name",
        },
        {
          text: "Nominal Code",
          value: "node.nominalCode",
          name: "nominalCode",
        },
        {
          text: "Tax Code",
          value: "node.taxCode",
          name: "taxCode",
        },
        {
          text: "Accommodation",
          value: "isAccommodation",
          name: "accommodation",
        },
        {
          text: "Activity",
          value: "isActivity",
          name: "activity",
        },
        {
          text: "Transport",
          value: "isTransport",
          name: "transport",
        },
        {
          text: "Travel",
          value: "isTravel",
          name: "travel",
        },
        {
          text: "Other",
          value: "isOther",
          name: "other",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.chargeTypes ? this.chargeTypes.edges : [];
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    filteredHeaders() {
      return this.headers.filter(
        (h) => this.visibleColumns.indexOf(h.name) > -1
      );
    },
  },

  methods: {
    createItem() {
      this.selectedCharge = {};
      this.chargeEditorDialog = true;
    },
    editItem(item) {
      this.selectedCharge = { ...item.node };
      this.chargeEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: CHARGE_TYPE_DELETE_MUTATION,
          variables: {
            chargeTypeId: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Charge type removed." });
      if (this.$apollo.queries.chargeTypes != null) {
        this.$apollo.queries.chargeTypes.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name === fieldName);
    },
    onSaved(context) {
      if (this.$apollo.queries.chargeTypes != null) {
        this.$apollo.queries.chargeTypes.refetch();
      }
      this.onResetSave();
      this.chargeEditorDialog = false;
      this.selectedCharge = {};
      let msg =
        context == "edit" ? "Charge type updated." : "Charge type created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onResetSave() {
      this.doSaveCharge = false;
    },
    closeDialog() {
      this.chargeEditorDialog = false;
      this.selectedCharge = {};
    },
    onSaveExtra() {
      this.doSaveCharge = true;
    },
    onSaveCharge(payload) {
      this.chargeEditorDialog = false;
      const { id, ...input } = payload;
      const mutation = id
        ? CHARGE_TYPE_UPDATE_MUTATION
        : CHARGE_TYPE_CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation,
          variables: { id, input },
          refetchQueries: [
            {
              query: ALL_CHARGE_TYPES_SEARCH_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Charge Type Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
  },

  apollo: {
    chargeTypes: {
      query: ALL_CHARGE_TYPES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {},
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/ChargesTypesList.vue